import { createTheme, ThemeOptions } from '@mui/material/styles'
import * as CSS from 'csstype'

export const defaultThemeOptions: ThemeOptions = {
  palette: {
    primary: {
      main: '#0C7D96',
      contrastText: '#FFFCFA'
    },
    secondary: {
      main: '#3AC1AD'
    },
    error: {
      main: '#E34E27'
    },
    info: {
      main: '#E34E27'
    },
    background: {
      default: '#FFFCFA',
      paper: '#FFFCFA'
    },
    text: {
      primary: '#442B37',
      secondary: '#818181'
    },
    divider: '#442B3730'
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '24px',
          paddingLeft: '30px',
          paddingRight: '30px',
          textTransform: 'none' as CSS.Property.TextTransform,
          whiteSpace: 'nowrap' as CSS.Property.WhiteSpace
        },
        containedSecondary: {
          backgroundColor: '#E34E27',
          color: '#ffffff',
          '&:hover': {
            backgroundColor: '#E34E27'
          }
        }
      }
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          color: '#442B37'
        }
      }
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          marginLeft: '8px',
          marginRight: '8px',
          minHeight: '40px'
        },
        indicator: {
          display: 'none'
        },
        scrollButtons: {
          height: '30px'
        }
      }
    },
    MuiTab: {
      styleOverrides: {
        root: {
          height: '28px',
          minHeight: '28px',
          marginLeft: '8px',
          marginRight: '8px',
          fontFamily: ['"Syne"', '"Syne Fallback"', 'sans-serif'].join(','),
          fontWeight: 500,
          fontSize: '14px',
          padding: '5px 10px',
          color: '#442B37',
          '&.Mui-selected': {
            background: '#335591',
            borderRadius: '8px',
            color: '#FFFFFF'
          }
        }
      }
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          backgroundColor: '#442B3730'
        }
      }
    },
    MuiInput: {
      styleOverrides: {
        input: {
          '&::placeholder': {
            color: '#7B849D'
          }
        }
      }
    },
    MuiButtonBase: {
      styleOverrides: {
        root: {
          border: '1px solid transparent',
          disableRipple: true
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          border: '1px solid transparent',
          borderRadius: '6px',
          backgroundColor: '#FFFCFA20',
          fontSize: '14px',
          lineHeight: '19px',
          '&$multiline': {
            padding: '14px'
          },
          '&$focused $notchedOutline': {
            borderColor: '#0091B0',
            borderWidth: '1px'
          }
        },
        notchedOutline: {
          borderColor: '#7B849D'
        }
      }
    }
  },
  typography: {
    fontFamily: ['Inter', '"Inter Fallback"', 'sans-serif'].join(','),
    h1: {
      fontWeight: 400,
      fontSize: '48px'
    },
    h2: {
      fontWeight: 400,
      fontSize: '36px'
    },
    h3: {
      fontWeight: 400,
      fontSize: '24px',
      lineHeight: '31px'
    },
    h4: {
      fontWeight: 500,
      fontSize: '18px',
      lineHeight: '22px'
    },
    h5: {
      fontWeight: 500,
      fontSize: '14px',
      lineHeight: '17px'
    },
    h6: {
      fontWeight: 500,
      fontSize: '12px',
      lineHeight: '18px'
    },
    body1: {
      fontWeight: 400,
      fontSize: '15px',
      lineHeight: '19px'
    },
    body2: {
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '16px'
    },
    overline: {
      fontWeight: 400,
      fontSize: '12px',
      lineHeight: '15px'
    }
  },
  spacing: 8,
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920
    }
  }
}

const defaultTheme = createTheme(defaultThemeOptions)

export default defaultTheme
